<template>
  <div ref="product-list-container">
    <SortOrder
      :sortOrder="sortOrder"
      :sortBy="sortBy"
      class="mb-4"
      @order-change="handleOrderChange"
    />

    <div v-if="isFetching" class="products row mb-3">
      <div class="col-md-4" v-for="i in 24" :key="i">
        <content-placeholders>
          <content-placeholders-img />
          <content-placeholders-heading />
        </content-placeholders>
      </div>
    </div>

    <div class="p-5 text-center" v-else-if="!productList.length">
      <p>
        <i>No products found... </i>
      </p>
    </div>

    <div v-else-if="productList" class="products row">
      <ProductCard
        v-for="product in productList[page - 1]"
        :key="product.id"
        :product="product"
        class="products__item col-sm-6 col-md-6 col-lg-4"
      />
    </div>

    <paginate
      style="flex-wrap: wrap"
      :page-count="totalPages"
      :click-handler="handlePageChange"
      :prev-text="'vorige'"
      :next-text="'volgende'"
      v-model="pagination.currentPage"
      :container-class="'pagination'"
    >
    </paginate>
  </div>
</template>

<script>
import ProductCard from "@/components/ProductCard";
import SortOrder from "@/components/SortOrder";

export default {
  name: "ProductList",
  components: {
    ProductCard,
    SortOrder,
  },
  props: {
    isFetching: Boolean,
    productList: {
      type: Array,
      default: () => [],
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    page: {
      type: Number,
      default: 1,
    },
    sortOrder: {
      type: String,
      default: "desc",
    },
    sortBy: {
      type: String,
      default: "price",
    },
  },
  data() {
    return {
      pagination: {
        perPage: 12,
        currentPage: 1,
        totalResult: 0,
      },
    };
  },
  methods: {
    setProductListToFirst() {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.$router.query,
          product_page: 1,
        },
      });
    },

    handleOrderChange(e) {
      this.setProductListToFirst();
      this.$emit("order-change", e);
    },

    handlePageChange(e) {
      this.$emit("page-change", e);
    },
  },
  watch: {
    page(newVal) {
      this.pagination.currentPage = newVal;
    },
  },
};
</script>

<style></style>
